import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import Image from "next/image";
import vimal from "../../assets/vimal.jpeg";
import achivement from "../../assets/achivement.jpeg";
import birthday from "../../assets/birthday.jpeg";

const WorkLife = () => {
  return (
    <Box sx={{ margin: { xs: "2rem auto", sm: "4rem auto 2rem" } }}>
      <Grid container alignItems="center" justifyContent="space-between">
        {/* Left Side - Images */}
        <Grid
          item
          xs={12}
          md={6}
          sx={{ position: "relative", height: { xs: "30rem", sm: "33rem" } }}
        >
          <Box
            sx={{
              position: "absolute",
              top: 0,
              right: 0,
              width: "100%",
              maxWidth: { xs: "220px", sm: "250px" },
              borderRadius: "10px",
              boxShadow: "0 0 20px 1px rgba(0, 0, 0, 0.2)",
              overflow: "hidden",
            }}
          >
            <Image
              src={vimal}
              alt="Work Image"
              width={500}
              height={500}
              style={{
                borderRadius: "8px",
                objectFit: "cover",
              }}
            />
          </Box>

          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: { xs: "170px", sm: "200px" },
              height: "auto",
              borderRadius: "10px",
              boxShadow: "0 0 20px 1px rgba(0, 0, 0, 0.2)",
              overflow: "hidden",
            }}
          >
            <Image
              src={birthday}
              alt="Work Image"
              width={500}
              height={500}
              style={{ borderRadius: "8px", objectFit: "cover" }}
            />
          </Box>

          <Box
            sx={{
              position: "absolute",
              bottom: 0,
              left: 0,
              width: { xs: "auto", sm: "500px" },
              height: "auto",
              borderRadius: "10px",
              boxShadow: "0 0 20px 1px rgba(0, 0, 0, 0.2)",
              overflow: "hidden",
            }}
          >
            <Image
              src={achivement}
              alt="Work Image"
              width={500}
              height={500}
              style={{
                borderRadius: "8px",
                objectFit: "cover",
              }}
            />
          </Box>
        </Grid>

        {/* Right Side - Mission Statement */}
        <Grid item xs={12} md={5.5}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              color: "#15741a",
              textTransform: "uppercase",
              marginBottom: "1rem",
              fontSize: { xs: "24px", sm: "34px" },
              marginTop: { xs: "2rem", sm: "0px" },
            }}
          >
            The SalonTym Mission
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: "#555",
              fontSize: "1.1rem",
              lineHeight: { xs: 1.5, sm: 1.8 },
              textAlign: "justify",
            }}
          >
            Where Team Happiness Sparks Excellence and Fun Fuels Success! We
            believe that a positive workplace culture leads to outstanding
            results. Our team thrives on collaboration, creativity, and a shared
            passion for excellence. At SalonTym, every success is a team effort,
            and every challenge is an opportunity to grow together.
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default WorkLife;
